import widgetArea from '../widget/widget-area'
import widget from '../widget/widget'

import contactFormWidget from '../widgets/general/contact-form'
import faqWidget from '../widgets/general/faq'
import formBuilderWidget from '../widgets/general/form-builder'
import htmlWidget from '../widgets/general/html'
import imageWithTextWidget from '../widgets/general/image-with-text'
import inlineImageWidget from '../widgets/general/inline-image'
import inlineVideoWidget from '../widgets/general/inline-video'
import textWidget from '../widgets/general/text'
import videoWidget from '../widgets/general/video'
import ctaWidget from '../widgets/general/cta'
import textHeroWidget from '../widgets/general/text-hero'
import headerWidget from '../widgets/general/header'
import productPromoWidget from '../widgets/general/product-promo'
import articleGridWidget from '../widgets/general/article-grid'
import assetGridWidget from '../widgets/general/asset-grid'
import productGridWidget from '../widgets/general/product-grid'

const widgets = [
  widget(),

  headerWidget(),
  contactFormWidget(),
  faqWidget(),
  formBuilderWidget(),
  htmlWidget(),
  imageWithTextWidget(),
  inlineImageWidget(),
  inlineVideoWidget(),
  textWidget(),
  videoWidget(),
  ctaWidget(),
  textHeroWidget(),
  productPromoWidget(),
  articleGridWidget(),
  assetGridWidget(),
  productGridWidget()
]

const createQuery = () => `
  body {
    ${widgetArea(widgets)}
  }
`
export default createQuery
